export default "__VITE_ASSET__fitpp_xK__";